import { filesystem } from '../init'

export async function getLastUserFromDevice (): Promise<number | undefined> {
  if ( filesystem !== undefined ){
    return await filesystem.read<number>( filesystem.getPath('last-user') )
  }
}

export async function updateLastUserFile (user?: number): Promise<void> {
  if ( filesystem !== undefined ){
    await filesystem.write( filesystem.getPath('last-user'), user ?? '' )
    if ( user !== undefined ) await filesystem.setUser( user )
  }
}
